import {GuessModelV1} from 'resources/GeneratedModels/Guess/GuessModel.v1';

import isGuessOrDraftGuessEmpty from 'resources/extensions/isGuessOrDraftGuessEmpty';

export type GuessCorrectness = 'incorrect' | 'partiallyCorrect' | 'correct';

GuessModelV1.extend({
  getCorrectness(partialCreditEnabled = false): GuessCorrectness {
    const grade = this.getGrade();

    if (partialCreditEnabled && grade > 0 && grade < 1) {
      return 'partiallyCorrect';
    } else if (grade === 1) {
      return 'correct';
    }

    return 'incorrect';
  },
  getGrade(): number {
    let grade = this.get('grade');

    // Guesses placed before partial-credit grading shipped have no stored grade,
    // so fall back to the binary correct/incorrect signal for historical data.
    if (typeof grade !== 'number') {
      grade = this.isCorrect() ? 1 : 0;
    }

    return grade;
  },
  // Immutable maps already have an isEmpty method, so this method is named to avoid overwriting that method.
  isGuessEmpty() {
    return isGuessOrDraftGuessEmpty(this);
  },
  async submitGuess({userId, assignmentId = false, questionType, withStandards = true}) {
    const saveArgs = {
      customQuery: {
        include: [
          'question_v3.question_set_v1.subject_v2',
          ...(withStandards
            ? ['question_v3.standards_v1', 'question_v3.standards_v1.standard_set_v1']
            : []),
          'question_v3.question_set_v1.tags_v1'
        ].join(','),
        customQuery: {
          // `standard_v1` meta and `personalization_settings` travel together: `StandardsList`
          // filters the post-guess chips on the meta this context populates.
          with_meta: withStandards ? 'question_v3,standard_v1' : 'question_v3',
          meta: {
            context: {
              ...(assignmentId
                ? {
                    assignment: {
                      id: assignmentId
                    }
                  }
                : {}),
              user: {
                id: userId,
                ...(withStandards ? {personalization_settings: true} : {})
              }
            }
          }
        }
      }
    };
    if (questionType === 'graph-contains') {
      saveArgs.customQuery.customQuery.with_meta += ',guess_v1';
      // @ts-expect-error
      saveArgs.customQuery.customQuery.meta.context.correctness_context = true;
    }
    return this.updateRelationship('assignment_v3', assignmentId, assignmentId).save(saveArgs);
  }
});

export {GuessModelV1};
